export interface ShareOptions {
  title: string;
  abstract: string;
  own_url: string;
  image_url: string;
}

export const enum ShareConfigItemTypeEnum {
  Copy = 'copy',
  Qrcode = 'qrcode',
  PYQ = 'pyq',
  WX = 'wx'
}

export interface ShareConfigItem {
  type: ShareConfigItemTypeEnum;
  title: string;
  icon: string;
  onClick?: (options: ShareOptions) => void;
}
